import { SimpleStatRecord } from "@/includes/types/DashboardExtended/types";

import { sum } from "lodash";

export const sumCombinedRatesValues = (model: Array<SimpleStatRecord> = []):number => {
  return sum(model.map(d => d ? d.value : 0))
}
